import React from "react";

function HeaderTitle({ title }) {
  return (
    <>
      <div className="card card-bg head-line mt-2 mb-2">
        <div className="text-light">
          <h4 className="mx-3 text-yellow-500 fw-bolder text-center p-2">
            {title}
          </h4>
        </div>
      </div>
      {/* <div className="heandTitle bg-dark" style={{ borderRadius: 10 }}>
        <div className="text-light p-2 text-center">
          <h4> {title}</h4>
        </div>
      </div> */}
    </>
  );
}

export default HeaderTitle;
